import { api } from './client';
import type { Store, StoreCreateRequest, StoreUpdateRequest } from '../types';

export const storesApi = {
  list: () => api.get<Store[]>('/stores').then((r) => r.data),

  get: (id: number) => api.get<Store>(`/stores/${id}`).then((r) => r.data),

  create: (body: StoreCreateRequest) =>
    api.post<Store>('/stores', body).then((r) => r.data),

  update: (id: number, body: StoreUpdateRequest) =>
    api.put<Store>(`/stores/${id}`, body).then((r) => r.data),
};
